
import Vue from "vue";
import {BIconstack, BIcon, BIconBellFill, BIconCartFill, BIconCircle, BIconCircleFill, BIconPlus} from "bootstrap-vue";

export default Vue.extend({
  name: "AddToCartIcon",
  components: {
    // CustomPlusIcon,
    BIconstack,
    // eslint-disable-next-line vue/no-unused-components
    BIconCircleFill,
    // eslint-disable-next-line vue/no-unused-components
    BIconBellFill,
    // eslint-disable-next-line vue/no-unused-components
    BIconCircle,
    // eslint-disable-next-line vue/no-unused-components
    BIconCartFill,
    // eslint-disable-next-line vue/no-unused-components
    BIconPlus,
    // eslint-disable-next-line
    BIcon,
  },
});
